<template>
  <!-- 员工转岗审批 -->
  <div>
    <Collapse v-model="value2" simple disabled style="border: 0">
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="基本信息" />
        <Form
          ref="formValidate"
          :model="formItem"
          :rules="Validate"
          slot="content"
          :label-width="150"
          label-position="left"
          class="titleDistance"
          disabled
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工工号">
                <Input
                  :disabled="isHistory"
                  placeholder=""
                  v-model="formItem.applyUserId"
                >
                  <Button
                    slot="append"
                    icon="ios-search"
                    :disabled="isHistory"
                  ></Button>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工姓名">
                <Input disabled v-model="formItem.applyName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="紧急程度">
                <Select
                  v-model="formItem.gradeType"
                  :clearable="true"
                  placeholder=""
                  :disabled="isHistory"
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in gradeTypeList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="申请日期">
                <Date-picker
                  v-model="formItem.applyDate"
                  disabled
                  type="date"
                  placeholder=""
                  style="width:100%"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="变更生效日" prop="effectiveDate">
                <Date-picker
                  v-model="formItem.effectiveDate"
                  :disabled="isHistory"
                  type="date"
                  placeholder=""
                  style="width:100%"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="人事变更履历" />
        <Tabs :animated="true" class="titleDistance" slot="content" disabled>
          <Tab-pane label="人事变更履历" style="width: 100%">
            <Row>
              <Col span="24">
                <Table border :columns="columns1" :data="HRChangeData"></Table>
              </Col>
            </Row>
            <Row>
              <Col
                span="24"
                style="margin-top: 20px; display: flex; justify-content: flex-end;"
              >
                <Page :total="total1" @on-change="pageChange1" />
              </Col>
            </Row>
          </Tab-pane>
        </Tabs>
      </Panel>
      <Panel name="3" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="人事变更" />
        <Form
          :label-width="120"
          slot="content"
          label-position="left"
          class="titleDistance"
          disabled
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="人事变更类型">
                <Select
                  v-model="formItem.hrChangeType"
                  :clearable="true"
                  placeholder=""
                  :disabled="isHistory"
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in HRChangeTypeList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构1">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode1"
                  :disabled="isHistory"
                >
                  <Option
                    v-for="(item, index) in hierarchyOne"
                    :value="item.orgcode1"
                    :key="index"
                    >{{ item.orgcode1 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构2">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode2"
                  :disabled="isHistory"
                >
                  <Option
                    v-for="(item, index) in hierarchyTwo"
                    :value="item.orgcode2"
                    :key="index"
                    >{{ item.orgcode2 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构3">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode3"
                  :disabled="isHistory"
                >
                  <Option
                    v-for="(item, index) in hierarchyThree"
                    :value="item.orgcode3"
                    :key="index"
                    >{{ item.orgcode3 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构4">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode4"
                  :disabled="isHistory"
                >
                  <Option
                    v-for="(item, index) in hierarchyFour"
                    :value="item.orgcode4"
                    :key="index"
                    >{{ item.orgcode4 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构5">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode5"
                  :disabled="isHistory"
                >
                  <Option
                    v-for="(item, index) in hierarchyFive"
                    :value="item.orgcode5"
                    :key="index"
                    >{{ item.orgcode5 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构6">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode6"
                  :disabled="isHistory"
                >
                  <Option
                    v-for="(item, index) in hierarchySix"
                    :value="item.orgcode6"
                    :key="index"
                    >{{ item.orgcode6 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构7">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode7"
                  :disabled="isHistory"
                >
                  <Option
                    v-for="(item, index) in hierarchySeven"
                    :value="item.orgcode7"
                    :key="index"
                    >{{ item.orgcode8 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构8">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode8"
                  :disabled="isHistory"
                >
                  <Option
                    v-for="(item, index) in hierarchyEight"
                    :value="item.orgcode8"
                    :key="index"
                    >{{ item.orgcode8 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构9">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode9"
                  :disabled="isHistory"
                >
                  <Option
                    v-for="(item, index) in hierarchyNine"
                    :value="item.orgcode9"
                    :key="index"
                    >{{ item.orgcode9 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构10">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode10"
                  :disabled="isHistory"
                  @on-change="getCJCode"
                >
                  <Option
                    v-for="(item, index) in hierarchyTen"
                    :value="item.orgcode10"
                    :key="index"
                    >{{ item.orgcode10 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="是否已告知本人">
                <Checkbox
                  v-model="formItem.beNotifyOneself"
                  true-value="1"
                  fasle-value="0"
                  :disabled="isHistory"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="鞋柜是否调整">
                <Checkbox
                  v-model="formItem.beShoes"
                  true-value="1"
                  fasle-value="0"
                  :disabled="isHistory"
                ></Checkbox>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="衣柜是否调整">
                <Checkbox
                  v-model="formItem.beWardrobe"
                  true-value="1"
                  fasle-value="0"
                  :disabled="isHistory"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="班车是否调整">
                <Checkbox
                  v-model="formItem.beBus"
                  true-value="1"
                  fasle-value="0"
                  :disabled="isHistory"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="班车原路线">
                <Input
                  v-model="formItem.busOriginalRoute"
                  :disabled="isHistory"
                />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="班车新路线">
                <Input v-model="formItem.busNewRoute" :disabled="isHistory" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="预定职位（原）">
                <Input
                  v-model="formItem.reservePositionOriginal"
                  :disabled="isHistory"
                />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="预定职位（新）">
                <Input
                  :disabled="isHistory"
                  v-model="formItem.reservePositionNew"
                />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="成本中心">
                <Input :disabled="isHistory" v-model="formItem.costCenter" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="24">
              <FormItem span="3" label="变更原因">
                <Input
                  type="textarea"
                  v-model="formItem.changeReason"
                  :disabled="isHistory"
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="4" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="职位变更履历" />
        <Tabs :animated="true" class="titleDistance" slot="content" disabled>
          <Tab-pane label="职位变更履历" style="width: 100%">
            <Row>
              <Col span="24">
                <Table
                  border
                  :columns="columns4"
                  :data="positionChangeDate"
                ></Table>
              </Col>
            </Row>
            <Row>
              <Col
                span="24"
                style="margin-top: 20px; display: flex; justify-content: flex-end;"
              >
                <Page :total="total2" @on-change="pageChange2" />
              </Col>
            </Row>
          </Tab-pane>
        </Tabs>
      </Panel>
      <Panel name="5" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="职位信息" />
        <Form
          :label-width="150"
          slot="content"
          label-position="left"
          class="titleDistance"
          disabled
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label-width="150" label="职位编号">
                <Input disabled v-model="formItem.positionNo">
                  <Button slot="append" icon="ios-search"></Button>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label-width="150" label="职位描述（中文）">
                <Input disabled v-model="formItem.positionCname" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label-width="150" label="职位描述（英文）">
                <Input disabled v-model="formItem.positionEname" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label-width="150" label="职位变更原因">
                <Select
                  v-model="formItem.positionChangeReason"
                  :clearable="true"
                  placeholder=""
                  :disabled="isHistory"
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in changeReasonList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label-width="150" label="直线主管">
                <Input
                  :disabled="isHistory"
                  placeholder=""
                  v-model="formItem.lineSupervisor"
                >
                  <Button
                    slot="append"
                    icon="ios-search"
                    :disabled="isHistory"
                  ></Button>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label-width="150" label="直线主管职位">
                <Input
                  :disabled="isHistory"
                  v-model="formItem.lineSupervisorPosition"
                />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="18">
              <div class="form-inline">
                <FormItem label="附件" style="margin-top:15px">
                  <j2-FileUP
                    ref="file1"
                    @handleDel="fileDel"
                    @handleOK="fileSuc"
                    disabled
                    :file_type="{ resourceType: 'Transfer_Attachment' }"
                    :resourceId="formItem.transfer_attachment"
                  ></j2-FileUP>
                </FormItem>
              </div>
            </Col>
          </Row>
        </Form>
      </Panel>
    </Collapse>
    <Row class="btnRight">
      <Col>
        <Button class="applyBtnRight" v-if="!isHistory" @click="submitt">{{
          $t("同意")
        }}</Button>
        <Button
          v-if="!getQueryVariable('history')"
          class="applyBtnRight"
          @click="reject"
          >{{ $t("驳回") }}</Button
        >
        <!-- <Button v-if="!getQueryVariable('history') " class="applyBtnRight" @click="goBack">{{$t('退回')}}</Button> -->
        <Button class="applyBtnRight" @click="returnPage">{{
          $t("返回")
        }}</Button>
      </Col>
    </Row>
    <!-- 审批历史 -->
    <div v-if="isHistory">
      <FormTitle :titleText="$t('审批历史')" style="margin-top: 30px" />
      <Table border :columns="columns3" :data="data3" class="titleDistance">
      </Table>
    </div>
    <Modal
      v-model="showdataAgree"
      :title="$t('请填写审批意见')"
      width="500"
      :mask-closable="false"
    >
      <Input v-model="rejectMessage.message" type="textarea" :rows="5"></Input>
      <div slot="footer">
        <Button @click="yess1">{{ $t("确定") }}</Button>
        <Button @click="cancell1">{{ $t("取消") }}</Button>
      </div>
    </Modal>
    <Modal
      v-model="showdataRejected"
      :title="$t('请填写驳回意见')"
      width="500"
      :mask-closable="false"
    >
      <Form :rules="ruleValidate" :model="rejectMessage" ref="rejectMessage">
        <FormItem prop="message">
          <Input
            v-model="rejectMessage.message"
            type="textarea"
            :rows="5"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="yess2">{{ $t("确定") }}</Button>
        <Button @click="cancell2">{{ $t("取消") }}</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      value2: [1, 2, 3, 4, 5],
      formItem: {
        status: ""
      },
      Validate: {
        effectiveDate: [{ required: true, message: "请选择变更生效日" }]
      },
      formItem2: {},
      filter: {},
      filter1: {},
      filter2: {},
      fileInfo: {
        transferFile: ""
      },
      action: "/api/resource/upload",
      empoloyee: false,
      executive: false,
      columns1: [
        {
          title: "变更有效日",
          key: "effectiveDate",
          align: "center",
          width: "200",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.effectiveDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "组织架构1",
          key: "orgCode1",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构2",
          key: "orgCode2",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构3",
          key: "orgCode3",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构4",
          key: "orgCode4",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构5",
          key: "orgCode5",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构6",
          key: "orgCode6",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构7",
          key: "orgCode7",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构8",
          key: "orgCode8",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构9",
          key: "orgCode9",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构10",
          key: "orgCode10",
          align: "center",
          width: "200"
        }
      ],
      HRChangeData: [], //人事变更履历
      columns4: [
        {
          title: "职位开始日",
          key: "effectiveDate",
          align: "center",
          width: "200",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.effectiveDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "职位编号",
          key: "positionNo",
          align: "center"
        },
        {
          title: "职位描述（中文）",
          key: "positionCname",
          align: "center"
        },
        {
          title: "职位描述（英文）",
          key: "positionEname",
          align: "center"
        },
        {
          title: "职位变更原因",
          key: "positionChangeReason",
          align: "center",
          render: (h, params) => {
            var position = "";
            this.changeReasonList.forEach(item => {
              if (params.row.positionChangeReason == item.code) {
                position = item.name;
              }
            });
            return h("span", position);
          }
        }
      ],
      positionChangeDate: [], //职位变更履历
      data2: [], //员工数据
      gradeTypeList: [], //紧急程度下拉框
      HRChangeTypeList: [], //人事变更类型下拉框
      changeReasonList: [], //职位变更原因
      isReadonly: false,
      columns2: [
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "150"
        },
        {
          title: "员工工号",
          key: "empCode",
          align: "center"
        },
        {
          title: "员工姓名",
          key: "userName",
          align: "center"
        },
        {
          title: "职位名称",
          key: "positionName",
          align: "center"
        }
      ],
      pageInfo: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pageInfo1: {
        itemCount1: 0,
        pageNum1: 1,
        pageSize1: 10
      },
      total1: 0,
      pageInfo2: {
        itemCount2: 0,
        pageNum2: 1,
        pageSize2: 10
      },
      total2: 0,
      columns5: [
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "150"
        },
        {
          title: "主管工号",
          key: "empcode",
          align: "center"
        },
        {
          title: "主管姓名",
          key: "cname",
          align: "center"
        },
        {
          title: "职位名称",
          key: "positionName",
          align: "center"
        }
      ],
      data5: [], //主管数据
      pageInfo3: {
        itemCount3: 0,
        pageNum3: 1,
        pageSize3: 10
      },
      total3: 0,
      columns6: [
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "150"
        },
        {
          title: "职位编码",
          key: "positionNo",
          align: "center"
        },
        {
          title: "中文描述",
          key: "positionCname",
          align: "center"
        },
        {
          title: "英文描述",
          key: "positionEname",
          align: "center"
        }
      ],
      data6: [],
      pageInfo6: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total6: 0,
      showPosition: false,
      columns3: [
        {
          title: "审批流名称",
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title: "实际审批者",
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title: "审批时间",
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title: "审批状态",
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title: "审批意见",
          key: "message",
          align: "center",
          width: "465"
        }
      ],
      data3: [], //审批历史
      spinShow: false,
      prevent: false,
      isHistory: false,
      resourceId_List: [],
      serialnumber: null,
      hierarchyOne: [],
      hierarchyTwo: [],
      hierarchyThree: [],
      hierarchyFour: [],
      hierarchyFive: [],
      hierarchySix: [],
      hierarchySeven: [],
      hierarchyEight: [],
      hierarchyNine: [],
      hierarchyTen: [],
      showdataRejected: false,
      showdataAgree: false,
      rejectMessage: {},
      ruleValidate: {
        message: [{ required: true, message: this.$t("请填写驳回意见") + "！" }]
      }
    };
  },
  created() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
  },
  mounted() {
    this.getOptionList();
    this.getApplyData();
  },
  methods: {
    //查询申请信息
    getApplyData() {
      let arr = {
        instanceId: this.getQueryVariable("instanceId")
      };
      this.spinShow = true;
      axios.post("/transfer/selectTransferData", arr).then(res => {
        this.formItem = res.basicInfo;
        this.data3 = res.logMap;
        this.positionChangeDate = res.transferOrgHistoricals;
        this.HRChangeData = res.transferOrgHistoricals;
        this.getCJCode();
        if (this.formItem.fileName && this.formItem.fileattachment) {
          this.$refs.file1.resource_id = this.formItem.fileattachment;
          this.$refs.file1.fileName = this.formItem.fileName;
        }
        this.spinShow = false;
      });
    },
    //查询选择员工的信息
    getListDate() {},
    // 上传附件
    fileSuc(res_id) {
      this.formItem.file_attachment = res_id;
    },
    fileDel(res_id) {
      this.formItem.file_attachment = "";
      this.resourceId_List.push(res_id);
    },
    getCJCode() {
      let obj = {};
      this.$set(obj, "orgCode1", this.formItem.orgCode1);
      this.$set(obj, "orgCode2", this.formItem.orgCode2);
      this.$set(obj, "orgCode3", this.formItem.orgCode3);
      this.$set(obj, "orgCode4", this.formItem.orgCode4);
      this.$set(obj, "orgCode5", this.formItem.orgCode5);
      this.$set(obj, "orgCode6", this.formItem.orgCode6);
      this.$set(obj, "orgCode7", this.formItem.orgCode7);
      this.$set(obj, "orgCode8", this.formItem.orgCode8);
      this.$set(obj, "orgCode9", this.formItem.orgCode9);
      this.$set(obj, "orgCode10", this.formItem.orgCode10);
      let obj1 = {
        orgCode1: this.formItem.orgCode1 || "",
        orgCode2: this.formItem.orgCode2 || "",
        orgCode3: this.formItem.orgCode3 || "",
        orgCode4: this.formItem.orgCode4 || "",
        orgCode5: this.formItem.orgCode5 || "",
        orgCode6: this.formItem.orgCode6 || "",
        orgCode7: this.formItem.orgCode7 || "",
        orgCode8: this.formItem.orgCode8 || "",
        orgCode9: this.formItem.orgCode9 || "",
        orgCode10: this.formItem.orgCode10 || ""
      };
      axios.post("/transfer/selectOrgList", obj1).then(res => {
        this.hierarchyTwo = [];
        this.hierarchyThree = [];
        this.hierarchyFour = [];
        this.hierarchyFive = [];
        this.hierarchySix = [];
        this.hierarchySeven = [];
        this.hierarchyEight = [];
        this.hierarchyNine = [];
        this.hierarchySeven = [];
        this.$set(this.formItem, "orgCode1", obj.orgCode1);
        this.$set(this.formItem, "orgCode2", obj.orgCode2);
        this.$set(this.formItem, "orgCode3", obj.orgCode3);
        this.$set(this.formItem, "orgCode4", obj.orgCode4);
        this.$set(this.formItem, "orgCode5", obj.orgCode5);
        this.$set(this.formItem, "orgCode6", obj.orgCode6);
        this.$set(this.formItem, "orgCode7", obj.orgCode7);
        this.$set(this.formItem, "orgCode8", obj.orgCode8);
        this.$set(this.formItem, "orgCode9", obj.orgCode9);
        this.$set(this.formItem, "orgCode10", obj.orgCode10);
        if (res) {
          this.hierarchyOne = res.hierarchyone ? res.hierarchyone : null;
          this.hierarchyTwo = res.hierarchytwo ? res.hierarchytwo : null;
          this.hierarchyThree = res.hierarchythree ? res.hierarchythree : null;
          this.hierarchyFour = res.hierarchyfour ? res.hierarchyfour : null;
          this.hierarchyFive = res.hierarchyfive ? res.hierarchyfive : null;
          this.hierarchySix = res.hierarchysix ? res.hierarchysix : null;
          this.hierarchySeven = res.hierarchyseven ? res.hierarchyseven : null;
          this.hierarchyEight = res.hierarchyeight ? res.hierarchyeight : null;
          this.hierarchyNine = res.hierarchynine ? res.hierarchynine : null;
          this.hierarchyTen = res.hierarchyten ? res.hierarchyten : null;
        }
      });
    },
    //人事变更履历分页
    pageChange1(val) {
      this.pageInfo1.pageNum1 = val;
      this.getListDate();
    },
    //职位变更履历分页
    pageChange2(val) {
      this.pageInfo2.pageNum2 = val;
      this.getListDate();
    },
    //同意
    submitt() {
      this.showdataAgree = true;
    },
    yess1() {
      this.showdataAgree = false;
      this.spinShow = true;
      let arr2 = [
        {
          objData1: { approval_result: "0" },
          stringData1: this.getQueryVariable("taskId"),
          stringData2: this.rejectMessage.message,
          type: "B17"
        }
      ];
      axios.post("/process/execute", arr2).then(res => {
        // 同意之后的回写功能
        // let obj = {
        //   instanceId : this.getQueryVariable("instanceId")
        // }
        // axios.post("/transfer/insertHrmEmpposition", obj).then((res1) => {
        // })
        if (res) {
          this.spinShow = false;
          this.$Message.info(this.$t("Approval_Completed"));
          this.$router.push(
            "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
          );
        }
      });
    },
    cancell1() {
      this.showdataAgree = false;
    },
    //驳回
    reject() {
      this.showdataRejected = true;
    },
    yess2() {
      this.$refs["rejectMessage"].validate(valid => {
        if (valid) {
          let arr = [
            {
              objData1: { approval_result: "1" },
              stringData1: this.getQueryVariable("taskId"),
              stringData2: this.rejectMessage.message,
              type: "B17"
            }
          ];
          this.showdataRejected = false;
          this.spinShow = true;
          axios.post("/process/execute", arr).then(res => {
            this.spinShow = false;
            this.prevent = false;
            if (res) {
              this.$Message.info(this.$t("审批驳回成功"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            }
          });
        }
      });
    },
    cancell2() {
      this.showdataRejected = false;
    },
    //退回
    goBack() {},
    //查询下拉框
    getOptionList() {
      let arr = {};
      axios.post("/transfer/selectOptionList", arr).then(res => {
        this.gradeTypeList = res.filter(res => {
          if (res.type == "grade") return res;
        }); //紧急程度下拉框
        this.HRChangeTypeList = res.filter(res => {
          if (res.type == "personnel") return res;
        }); //人事变更类型下拉框
        this.changeReasonList = res.filter(res => {
          if (res.type == "CHANGEREASON") return res;
        }); //职位变更原因
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    returnPage() {
      if (this.isHistory) {
        this.$router.push(
          "/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27"
        );
      } else {
        this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27");
      }
    }
  }
};
</script>

<style scoped>
.titleDistance {
  margin: 30px 30px 0 30px;
}
.ivu-input-search {
  cursor: pointer;
  padding: 0 16px !important;
  color: #000 !important;
  background: #f8f8f9 !important;
  border-color: #dcdee2 !important;
  transition: all 0.2s ease-in-out;
  position: relative;
  z-index: 2;
}
.ivu-spin-fix {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 8;
  width: 101% !important;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/TransferApproval.vue